import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { URL_CALLCENTER_PORTAL } from '@/shared/config';
import { useLoadingStore } from '@/shared/lib/loadingStore';

/**
 * Backs the not-found page with the router state that explains why it was reached and a way out. Reads the location state carrying the isNotEnoughHolterProcessor flag, dismisses the global loading page on mount, and exposes a handler that navigates to the call centre portal.
 *
 * @returns An object carrying the router state and the onClickBack handler.
 */
const useNotFound = () => {
  const { state } = useLocation<{ isNotEnoughHolterProcessor?: boolean }>();

  const loadingPageAction = useLoadingStore((s) => s.loadingPage);

  /**
   * Sends the user back to the call centre portal from the not-found page. Assigns URL_CALLCENTER_PORTAL to document.location.href, leaving the single-page app entirely.
   *
   * @returns Nothing.
   */
  const onClickBack = () => {
    document.location.href = URL_CALLCENTER_PORTAL;
  };

  useEffect(() => {
    loadingPageAction();
  }, []);

  return { state, onClickBack };
};

export default useNotFound;
